import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'

interface RevertToPendingModalProps {
  visible: boolean
  onHide: () => void
  onConfirm: () => void
  loading?: boolean
}

export default function RevertToPendingModal({ visible, onHide, onConfirm, loading }: RevertToPendingModalProps) {
  const header = (
    <span style={{ color: '#B27668', fontWeight: 600, fontSize: '1.25rem' }}>
      Volver a pendiente
    </span>
  )

  const footer = (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', paddingBottom: '0.75rem' }}>
      <Button
        label='No'
        onClick={onHide}
        disabled={loading}
        style={{
          background: 'transparent',
          borderColor: '#3CB8BA',
          color: '#3CB8BA',
          fontWeight: 600,
          fontSize: '1rem',
          borderRadius: '6px',
          padding: '0.6rem 1.4rem',
        }}
      />
      <Button
        label='Sí, volver a pendiente'
        onClick={onConfirm}
        loading={loading}
        style={{
          background: '#3CB8BA',
          borderColor: '#3CB8BA',
          color: '#ffffff',
          fontWeight: 600,
          fontSize: '1rem',
          borderRadius: '6px',
          padding: '0.6rem 1.4rem',
        }}
      />
    </div>
  )

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={header}
      footer={footer}
      style={{ width: '480px', borderRadius: '12px', overflow: 'hidden' }}
      closable
      closeIcon='pi pi-times'
      pt={{
        closeButton: {
          style: { color: '#3CB8BA' },
        },
        footer: {
          style: { background: '#f5f5f5', borderTop: '1px solid #e5e7eb', padding: '1rem 1.5rem 1.5rem' }
        },
      }}
    >
      <p style={{ margin: 0, color: '#374151', fontSize: '0.95rem' }}>
        ¿Desea volver a pendiente este informe? La solicitud regresará a la lista de pendientes.
      </p>
    </Dialog>
  )
}
